module.exports = __webpack_public_path__ + "img/rightTrapezoid.5ea3c439.svg";